/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const postApiOffices200Schema = z.any();

export const postApiOfficesMutationRequestSchema = z.object({
  name: z.coerce.string().min(1).max(500),
  client: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  isVisible: z.boolean(),
});

export const postApiOfficesMutationResponseSchema = z.lazy(
  () => postApiOffices200Schema,
);
